<svg
  width="22"
  height="16"
  viewBox="0 0 22 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$restProps.class}
>
  <path
    d="M13.0196 16L12.3922 15.4118L19.3725 8.43137H0V7.56863H19.3725L12.3922 0.588235L13.0196 0L21.0196 8L13.0196 16Z"
    fill="#1C1C20"
  />
</svg>
